'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n'], ['\n    display: flex;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    padding-left: 0;\n'], ['\n    padding-left: 0;\n']);

var _wendysI18next = require('wendys-i18next');

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _FlagSelector = require('./FlagSelector');

var _FlagSelector2 = _interopRequireDefault(_FlagSelector);

var _CountryAndCurrency = require('./CountryAndCurrency');

var _CountryAndCurrency2 = _interopRequireDefault(_CountryAndCurrency);

var _dist = require('wendys-common-web-ui/dist');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _localizationHelper = require('../../lib/localizationHelper');

var _localizationHelper2 = _interopRequireDefault(_localizationHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var PropTypes = require('prop-types');
/**
 * Created by skoda02 on 10/17/16.
 */

var React = require('react');
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var _ = require('lodash');
var FloatLabelField = require('../FloatLabelField.js');
var PageTitle = require('../pageTitle.js').default;

module.exports = createReactClass({
    displayName: 'exports',

    propTypes: {
        isLoyaltyIntent: PropTypes.bool
    },
    getInitialState: function getInitialState() {
        this.currencyOptions = (0, _wendysI18next.getTranslatedString)('email_sign_up_currency_options');
        return {
            showFlagSelector: this.props.showFlagSelector,
            selectedLocale: {},
            flagUrl: '',
            checkedTerms: false,
            selectedCurrency: '',
            dropDownOptions: [],
            validationObj: {
                confirmedPassword: false,
                email: false,
                firstName: false,
                lastName: false,
                password: false,
                postalCode: false
            }
        };
    },
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
        if (this.props.showFlagSelector) {
            if (prevState.postalError !== this.state.postalError) this.checkFormValidity();
            return;
        }
        if (ReactDOM.findDOMNode(this.refs.postal_code) && !ReactDOM.findDOMNode(this.refs.postal_code).children[0].value && prevProps.postalCode != this.props.postalCode) {
            ReactDOM.findDOMNode(this.refs.postal_code).children[0].value = this.props.postalCode;
            if (this.refs.postal_code && this.refs.postal_code.isPopulated) {
                this.refs.postal_code.isPopulated({ currentTarget: { value: this.props.postalCode } });
            }
        }
    },
    componentDidMount: function componentDidMount() {
        if (this.props.setBackAction) {
            this.props.setBackAction(this.handleBackClick);
        }
        document.querySelector('#page-title').focus();
    },
    getForm: function getForm() {
        if (this.props.showFlagSelector) {
            return {
                firstName: ReactDOM.findDOMNode(this.refs.first_name).children[0].value,
                lastName: ReactDOM.findDOMNode(this.refs.last_name).children[0].value,
                login: ReactDOM.findDOMNode(this.refs.email).children[0].value,
                password: ReactDOM.findDOMNode(this.refs.password).children[0].value,
                terms: ReactDOM.findDOMNode(this.refs.terms).checked,
                optIn: false
            };
        }
        return {
            firstName: ReactDOM.findDOMNode(this.refs.first_name).children[0].value,
            lastName: ReactDOM.findDOMNode(this.refs.last_name).children[0].value,
            login: ReactDOM.findDOMNode(this.refs.email).children[0].value,
            password: ReactDOM.findDOMNode(this.refs.password).children[0].value,
            postal: ReactDOM.findDOMNode(this.refs.postal_code).children[0].value,
            terms: ReactDOM.findDOMNode(this.refs.terms).checked,
            optIn: false
        };
    },
    onSubmit: function onSubmit(e) {
        e.preventDefault();

        var form = this.getForm();
        var error = false;

        for (var prop in form) {
            if (!form[prop] && prop != 'optIn') {
                error = true;
            }
        }
        if (!error) {
            if (this.props.showFlagSelector) {
                form = _extends({}, form, {
                    cntry: this.state.selectedLocale.postValue,
                    postal: this.state.postalCode,
                    currency: (0, _find2.default)(this.currencyOptions, { value: this.state.selectedCurrency }).postValue
                });
            } else {
                form.cntry = this.mapPostalTypeToCntry(this.checkAddressCodeType(form.postal)); //added cntry to return based on zipcode type
            }
            if (this.props.handleRegistrationClick) {
                this.props.handleRegistrationClick(form);
            }
        } else {
            alert((0, _wendysI18next.getTranslatedString)('email_sign_up_submit_error'));
        }
    },
    checkFormValidity: function checkFormValidity() {
        var validationObj = this.state.validationObj;
        if (this.props.showFlagSelector) {
            delete validationObj.postalCode;
        }
        var disable = false;
        if (!_.isEmpty(validationObj)) {
            for (var prop in validationObj) {
                if (!validationObj[prop] || validationObj[prop] != true) {
                    disable = true;
                }
            }
        } else {
            disable = true;
        }
        if (!this.state.checkedTerms || this.state.postalError) {
            disable = true;
        }

        return !disable;
    },
    handleCheckBox: function handleCheckBox(cb) {
        this.setState({
            checkedTerms: cb.currentTarget.checked
        });
    },
    spliceError: function spliceError(idx) {
        if (this.props.removeErrorClick) {
            this.props.removeErrorClick(idx);
        }
    },
    handleFlagSelection: function handleFlagSelection() {
        var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var showFlagSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        this.setState({
            showFlagSelector: showFlagSelector,
            selectedLocale: locale,
            flagUrl: url,
            dropDownOptions: this.currencyOptions.map(function (obj) {
                return obj.value;
            }),
            selectedCurrency: locale.id ? (0, _find2.default)(this.currencyOptions, { id: locale.id }).value : ''
        });
    },
    changeSelectedCurrency: function changeSelectedCurrency(currencyChoice) {
        this.setState({
            selectedCurrency: currencyChoice
        });
    },
    isUSSelected: function isUSSelected() {
        return this.state.selectedLocale.id === 1;
    },
    getPostalCodeValue: function getPostalCodeValue(value, postalError) {
        this.setState({
            postalCode: value,
            postalError: postalError
        });
    },
    handleBackClick: function handleBackClick() {
        if (this.state.selectedLocale.id) {
            this.handleFlagSelection({}, '', true);
        } else {
            this.props.handleBackClick();
        }
    },
    renderCheckboxElement: function renderCheckboxElement() {
        var Config = require('../../lib/config').urls;
        var validLocale = (0, _localizationHelper2.default)(this.state.selectedLocale.postValue, '_');
        return React.createElement(
            'label',
            null,
            React.createElement('input', { required: true, type: 'checkbox', id: 'terms', ref: 'terms', onClick: this.handleCheckBox }),
            (0, _wendysI18next.getTranslatedString)('rewards_terms_and_conditions_preface'),
            React.createElement(
                'a',
                { href: Config.terms[validLocale], target: '_blank' },
                ' ',
                (0, _wendysI18next.getTranslatedString)('common_login_terms_of')
            ),
            ' ',
            (0, _wendysI18next.getTranslatedString)('common_login_and'),
            React.createElement(
                'a',
                { href: Config.privacy[validLocale], target: '_blank' },
                ' ',
                (0, _wendysI18next.getTranslatedString)('common_login_privacy_policy')
            ),
            '.'
        );
    },

    render: function render() {
        var _this = this;

        var that = this;
        var passwordRequirements = this.props.passwordRequirements || '';

        var formValidity = this.checkFormValidity();
        var disableSubmit = formValidity ? 'btn btn-primary' : 'btn btn-primary disable-submit';

        var errors = this.props.errors && this.props.errors.length > 0 ? React.createElement(
            'div',
            { ref: 'errorAlert', className: 'row' },
            React.createElement(
                'div',
                { className: 'col-xs-12 errors' },
                this.props.errors.map(function (error, idx) {
                    return React.createElement(
                        'div',
                        null,
                        React.createElement(
                            'p',
                            { className: 'bg-danger' },
                            error,
                            React.createElement(
                                'span',
                                { onClick: that.spliceError.bind(that, idx), className: 'clear-error', 'aria-hidden': 'true' },
                                '\xD7'
                            )
                        )
                    );
                })
            )
        ) : [];
        var descriptionText = (0, _wendysI18next.getTranslatedString)('comp_LoginModal_CreateAccount_SubText');
        if (this.props.isLoyaltyIntent) {
            descriptionText = (0, _wendysI18next.getTranslatedString)('comp_LoginModal_CreateAccount_SubText_Loyalty');
        }

        return React.createElement(
            'div',
            null,
            React.createElement(
                'div',
                { className: 'sign-up-container' },
                React.createElement(
                    'div',
                    { className: 'container' },
                    this.state.showFlagSelector ? React.createElement(_FlagSelector2.default, { handleFlagSelection: this.handleFlagSelection }) : React.createElement(
                        'div',
                        { className: 'col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2' },
                        React.createElement(PageTitle, {
                            titleText: (0, _wendysI18next.getTranslatedString)('email_sign_up_page_title')
                        }),
                        React.createElement(
                            'div',
                            { 'aria-live': 'polite' },
                            errors
                        ),
                        React.createElement(
                            'div',
                            { className: 'sign-up-form' },
                            React.createElement(
                                'div',
                                null,
                                React.createElement(
                                    'div',
                                    { className: 'sign-up-description' },
                                    descriptionText
                                ),
                                React.createElement(
                                    'form',
                                    { className: 'row', onSubmit: this.onSubmit },
                                    React.createElement(FloatLabelField, {
                                        required: true,
                                        type: 'text',
                                        id: 'first-name-input',
                                        onChangeHandler: this.validateFirstName,
                                        placeHolder: (0, _wendysI18next.getTranslatedString)('email_sign_up_first_name'),
                                        ref: 'first_name',
                                        customClass: 'col-sm-6 col-md-6 left'
                                    }),
                                    React.createElement(FloatLabelField, {
                                        required: true,
                                        type: 'text',
                                        id: 'last-name-input',
                                        onChangeHandler: this.validateLastName,
                                        placeHolder: (0, _wendysI18next.getTranslatedString)('email_sign_up_last_name'),
                                        ref: 'last_name',
                                        customClass: 'col-sm-6 col-md-6'
                                    }),
                                    React.createElement(FloatLabelField, {
                                        required: true,
                                        type: 'email',
                                        id: 'email-input',
                                        onChangeHandler: this.validateEmail,
                                        placeHolder: (0, _wendysI18next.getTranslatedString)('email_sign_up_email_address'),
                                        ref: 'email',
                                        customClass: 'col-sm-6 col-md-6 left'
                                    }),
                                    React.createElement(FloatLabelField, {
                                        type: 'text',
                                        id: 'dummy-input',
                                        placeHolder: 'dummy',
                                        ref: 'dummy',
                                        customClass: 'col-sm-6 col-md-6 blank'
                                    }),
                                    this.state.selectedLocale.id && React.createElement(_CountryAndCurrency2.default, {
                                        country: this.state.selectedLocale.value,
                                        flagUrl: this.state.flagUrl,
                                        currencyOptions: this.state.dropDownOptions,
                                        selectedCurrency: this.state.selectedCurrency,
                                        changeSelectedCurrency: this.changeSelectedCurrency
                                    }),
                                    this.props.showFlagSelector ? React.createElement(
                                        PostalRowWrapper,
                                        null,
                                        React.createElement(
                                            PostalWrapper,
                                            { className: 'col-sm-6 col-md-6 col-xs-12 left' },
                                            React.createElement(_dist.PostalCode, {
                                                USLabel: (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_code'),
                                                USError: (0, _wendysI18next.getTranslatedString)('email_sign_up_invalid_postal'),
                                                CALabel: (0, _wendysI18next.getTranslatedString)('email_sign_up_postal_code'),
                                                CAError: (0, _wendysI18next.getTranslatedString)('email_sign_up_invalid_postal'),
                                                isUSSelected: this.isUSSelected(),
                                                geocode: this.props.postalCode,
                                                description: (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_desc'),
                                                getValue: this.getPostalCodeValue
                                            })
                                        )
                                    ) : React.createElement(
                                        'div',
                                        null,
                                        React.createElement(FloatLabelField, {
                                            required: true,
                                            type: 'text',
                                            id: 'postal-input',
                                            onChangeHandler: this.validatePostalCode,
                                            placeHolder: (0, _wendysI18next.getTranslatedString)('email_sign_up_postal_code'),
                                            ref: 'postal_code',
                                            customClass: 'col-sm-6 col-md-6 left',
                                            inputAttributes: {
                                                'aria-describedby': 'field-description-zip'
                                            }
                                        }),
                                        React.createElement(FloatLabelField, {
                                            type: 'text',
                                            id: 'dummy-input',
                                            placeHolder: 'dummy',
                                            ref: 'dummy',
                                            customClass: 'col-sm-6 col-md-6 blank'
                                        }),
                                        React.createElement(
                                            'div',
                                            {
                                                id: 'field-description-zip',
                                                className: 'col-xs-12 field-description'
                                            },
                                            React.createElement(
                                                'div',
                                                null,
                                                (0, _wendysI18next.getTranslatedString)('email_sign_up_zip_desc')
                                            )
                                        )
                                    ),
                                    React.createElement(FloatLabelField, {
                                        required: true,
                                        type: 'password',
                                        id: 'password-input',
                                        onChangeHandler: function onChangeHandler(value, recursiveCheck) {
                                            return _this.validatePassword(value, recursiveCheck);
                                        },
                                        placeHolder: (0, _wendysI18next.getTranslatedString)('email_sign_up_password'),
                                        ref: 'password',
                                        customClass: 'col-sm-6 col-md-6 left',
                                        inputAttributes: {
                                            'aria-describedby': 'field-description-password'
                                        }
                                    }),
                                    React.createElement(FloatLabelField, {
                                        required: true,
                                        type: 'password',
                                        id: 'confirm-password-input',
                                        onChangeHandler: function onChangeHandler(value, recursiveCheck) {
                                            return _this.validateConfirmedPassword(value, recursiveCheck);
                                        },
                                        placeHolder: (0, _wendysI18next.getTranslatedString)('email_sign_up_confirm_password'),
                                        ref: 'confirmedPassword',
                                        customClass: 'col-sm-6 col-md-6'
                                    }),
                                    React.createElement(
                                        'div',
                                        {
                                            id: 'field-description-password',
                                            className: 'col-xs-12 field-description'
                                        },
                                        React.createElement(
                                            'div',
                                            null,
                                            passwordRequirements
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'col-xs-12 checkbox-container' },
                                        React.createElement(
                                            'div',
                                            null,
                                            this.renderCheckboxElement()
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'col-xs-12 sign-up-button ' },
                                        React.createElement(
                                            'button',
                                            {
                                                type: 'submit',
                                                className: disableSubmit,
                                                disabled: !formValidity,
                                                id: 'login-btn'
                                            },
                                            (0, _wendysI18next.getTranslatedString)('email_sign_up')
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        );
    },
    checkAndUpdateValidationObjectIfNeeded: function checkAndUpdateValidationObjectIfNeeded(validationObjProp, value) {
        if (this.state.validationObj[validationObjProp] != value) {
            var validationObj = _.cloneDeep(this.state.validationObj);
            validationObj[validationObjProp] = value;
            this.setState({ validationObj: validationObj });
        }
    },
    validateFirstName: function validateFirstName(input) {
        return this.checkRequiredValue('firstName', input);
    },
    validateLastName: function validateLastName(input) {
        return this.checkRequiredValue('lastName', input);
    },
    checkRequiredValue: function checkRequiredValue(validationField, input) {
        var retValue = "";
        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded(validationField, false);
            retValue = (0, _wendysI18next.getTranslatedString)("common_login_required");
        } else {
            this.checkAndUpdateValidationObjectIfNeeded(validationField, true);
        }
        return retValue;
    },
    validateEmail: function validateEmail(input) {
        var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/igm;
        var retValue = "";

        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded('email', false);
            retValue = (0, _wendysI18next.getTranslatedString)("common_login_required");
        } else if (input && !input.match(re)) {
            this.checkAndUpdateValidationObjectIfNeeded('email', false);
            retValue = (0, _wendysI18next.getTranslatedString)("common_login_invalid_email");
        } else {
            this.checkAndUpdateValidationObjectIfNeeded('email', true);
        }

        return retValue;
    },
    validatePostalCode: function validatePostalCode(input) {
        var retValue = "";

        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded('postalCode', false);
            retValue = (0, _wendysI18next.getTranslatedString)("common_login_required");
        } else if (!this.checkAddressCodeType(input)) {
            this.checkAndUpdateValidationObjectIfNeeded('postalCode', false);
            retValue = (0, _wendysI18next.getTranslatedString)("email_sign_up_invalid_postal");
        } else {
            this.checkAndUpdateValidationObjectIfNeeded('postalCode', true);
        }

        return retValue;
    },
    checkAddressCodeType: function checkAddressCodeType(code) {
        var zipRegex = /^(\d{5})?$/;
        var postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;

        var type = '';
        if (code.length == 7 && code.match(postalCodeRegex)) {
            type = 'postal';
        } else if (code.length == 5 && code.match(zipRegex)) {
            type = 'zip';
        }

        return type;
    },
    mapPostalTypeToCntry: function mapPostalTypeToCntry(postalType) {
        if (postalType == 'zip') {
            return 'US';
        } else if (postalType == 'postal') {
            return 'CA';
        } else {
            return '';
        }
    },
    validatePassword: function validatePassword(input, recursiveCheck) {
        var password = ReactDOM.findDOMNode(this.refs.confirmedPassword).children[0].value;
        var retValue = "";

        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded('password', false);
            retValue = (0, _wendysI18next.getTranslatedString)("common_login_required");
        } else if (password && input && input != password) {
            this.checkAndUpdateValidationObjectIfNeeded('password', false);
            retValue = (0, _wendysI18next.getTranslatedString)("email_sign_up_does_not_match");
        } else {
            this.checkAndUpdateValidationObjectIfNeeded('password', true);
            if (!recursiveCheck) {
                this.refs.confirmedPassword.isPopulated({ currentTarget: { value: password } }, true);
            }
        }

        return retValue;
    },
    validateConfirmedPassword: function validateConfirmedPassword(input, recursiveCheck) {
        var password = ReactDOM.findDOMNode(this.refs.password).children[0].value;
        var retValue = "";

        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded('confirmedPassword', false);
            retValue = (0, _wendysI18next.getTranslatedString)("common_login_required");
        } else if (password && input && input != password) {
            this.checkAndUpdateValidationObjectIfNeeded('confirmedPassword', false);
            retValue = (0, _wendysI18next.getTranslatedString)("email_sign_up_does_not_match");
        } else {
            this.checkAndUpdateValidationObjectIfNeeded('confirmedPassword', true);
            if (!recursiveCheck) {
                this.refs.password.isPopulated({ currentTarget: { value: password } }, true);
            }
        }

        return retValue;
    },
    hoverImage: function hoverImage(e) {
        if (e.target.src.indexOf('_hover_2.png') > -1) {
            e.target.src = e.target.src.replace('_hover_2.png', '_2.png');
        } else {
            e.target.src = e.target.src.replace('_2.png', '_hover_2.png');
        }
    }
});

var PostalRowWrapper = _styledComponents2.default.div(_templateObject);
var PostalWrapper = _styledComponents2.default.div(_templateObject2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/emailSignUp.js
// module id = 634
// module chunks = 0